import { useEffect, useState } from 'react'

export const PlainInput = (props: {
  value: string | number
  content: string | number
  onChange: (value: string) => void
  type?: 'text' | 'number' | 'string' | any
  className?: string
  isEditing?: boolean
  additionalElements?: JSX.Element | null
  [key: string]: any
}) => {
  const { value, content, onChange, type = 'text', className = '' } = props

  const [isEditing, setEditing] = useState<boolean | undefined>(false)
  const [editingValue, setEditingValue] = useState('')

  useEffect(() => {
    setEditingValue(value.toString())
  }, [value])

  useEffect(() => setEditing(props.isEditing), [props.isEditing])

  const onUpdate = () => {
    setEditing(false)
    setEditingValue(editingValue.trim())
    onChange(editingValue.trim())
  }

  return isEditing ? (
    <input
      autoFocus
      type={type}
      value={editingValue}
      onChange={(e) => setEditingValue(e.target.value)}
      className="w-full leading-4 p-1 block rounded-t border-gray-300 focus:border-sky-600 text-[14px] focus:outline-none focus:ring-0"
      onBlur={onUpdate}
    />
  ) : (
    <p
      className={`cursor-pointer p-1 min-h-[25px] leading-[29px] text-black font-variation-settings-600 ${className} flex items-center gap-2`}
      onClick={() => setEditing(true)}
    >
      {content} {props.additionalElements || null}
    </p>
  )
}
